export const NaturalLanguages: { language: string; progress: number }[] = [
    { language: 'Mandarin', progress: 100 },
    { language: 'Cantonese', progress: 95 },
    { language: 'English', progress: 55 },
    { language: 'Japanese', progress: 5 },
] as const

export const ProgrammingLanguages: { language: string; progress: number }[] = [
    { language: 'TypeScript', progress: 80 },
    { language: 'Java', progress: 60 },
    { language: 'Python', progress: 55 },
    { language: 'SQL', progress: 40 },
    { language: 'C++', progress: 35 },
    { language: 'PHP', progress: 30 },
    { language: 'HTML & CSS', progress: 30 },
    { language: 'Kotlin', progress: 25 },
    { language: 'Rust', progress: 15 },
] as const
